import { useDeleteFlexibleReportRequestMutation } from '@features/flexible-reports';
import {
  GridActionsCellItem,
  GridActionsCellItemProps,
} from '@mui/x-data-grid';
import { useCallback } from 'react';

type DeleteButtonProps = {
  gridActionsCellItemProps: GridActionsCellItemProps;
  campaignId: number;
  flexibleReportRequestId: number;
};

export const DeleteButton = (props: DeleteButtonProps) => {
  const { campaignId, flexibleReportRequestId } = props;
  const [deleteFlexibleReportRequest] =
    useDeleteFlexibleReportRequestMutation();

  const onClick = useCallback(async () => {
    await deleteFlexibleReportRequest({
      campaignId,
      flexibleReportRequestId,
    }).unwrap();
  }, [campaignId, flexibleReportRequestId, deleteFlexibleReportRequest]);

  return (
    <GridActionsCellItem
      {...props.gridActionsCellItemProps}
      onClick={() => void onClick()}
    />
  );
};
